import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import BackButtonDesktop from '../../components/BackButtonDesktop';

export default function CookiePolicy() {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom>
        Cookie Policy di DeskStudio
      </Typography>

      <Typography variant="subtitle2" gutterBottom>
        Ultimo aggiornamento: 20 Marzo 2026
      </Typography>

      <Box sx={{ mt: 3 }}>
        <Typography variant="h6">1. Cosa sono i cookie</Typography>
        <Typography paragraph>
          I cookie sono piccoli file di testo che vengono salvati sul dispositivo dell’utente per migliorare l’esperienza di navigazione.
        </Typography>

        <Typography variant="h6">2. Cookie utilizzati</Typography>
        <Typography paragraph>
          Utilizziamo le seguenti tipologie di cookie:
        </Typography>
        <ul>
          <li>Cookie tecnici (necessari al funzionamento del sito)</li>
          <li>Cookie di sessione per autenticazione</li>
          <li>Cookie analitici (in forma anonima)</li>
        </ul>

        <Typography variant="h6">3. Cookie tecnici</Typography>
        <Typography paragraph>
          Sono indispensabili per il funzionamento della piattaforma (login, sicurezza, gestione sessione) e non richiedono consenso.
        </Typography>

        <Typography variant="h6">4. Cookie analitici</Typography>
        <Typography paragraph>
          Utilizziamo strumenti come Google Analytics per raccogliere dati anonimi sull’utilizzo della piattaforma, al fine di migliorarla.
        </Typography>

        <Typography variant="h6">5. Cookie di terze parti</Typography>
        <Typography paragraph>
          Alcuni cookie possono essere installati da servizi esterni (es. Google Analytics), sempre in forma aggregata e anonima.
        </Typography>

        <Typography variant="h6">6. Gestione dei cookie</Typography>
        <Typography paragraph>
          L’utente può gestire o disabilitare i cookie direttamente dalle impostazioni del proprio browser.
        </Typography>

        <Typography variant="h6">7. Durata dei cookie</Typography>
        <ul>
          <li>Cookie di sessione: eliminati alla chiusura del browser</li>
          <li>Cookie analitici: fino a 14 mesi</li>
        </ul>

        <Typography variant="h6">8. Contatti</Typography>
        <Typography paragraph>
          Per informazioni: <strong>info@deskstudio.it</strong>
        </Typography>
      </Box>

      <BackButtonDesktop />
    </Container>
  );
}